export default __webpack_public_path__ + "static/media/photo--sm--reception.5c1106d2.jpg";